const config = require('../config');
const apiConfig = require('../api-config');
const apiFactory = require('../resources/userprofile/api-factory');
const serviceFactory = require('../resources/userprofile/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}]';

  return app => app
    .match((`${p}getUserProfileDetails`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.get(req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((`${p}saveUserPrefLanguage[{keys:inputParam}][{keys:guidStr}]`), requests => {
      return Promise.all(requests.map(({ req, res }) =>
        service.save(req.params.metaData, req.params.inputParam)
          .then(xs => res.value(xs))
          .catch(res.error)
      ))
    }
    )
    .match(`${p}userprofile.setUserPreferredLanguage[{keys:inputparams}][{keys:ran_str}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.setUserPreferredLanguage(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))
    .match((
      `${p}userprofile.updateDeviceDetails[{keys:deviceCode}][{keys:deviceModel}][{keys:deviceOs}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.updateDeviceDetails(req.params.deviceCode, req.params.deviceModel, req.params.deviceOs, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
      .match((`${p}userprofile.getPfMapData`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getPfMapData(req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      .match((`${p}userprofile.saveFileDownloadConsent[{keys:inputParam}]`), requests => 
      Promise.all(requests.map(({ req, res }) =>
          service.saveFileDownloadConsent(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      )))
      .match((`${p}userprofile.getSepaIpLimit[{keys:inputs}][{keys:guidStr}]`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.getSepaIpLimit(req.params.inputs, req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
      )))
      .match((`${p}userprofile.saveSepaIpLimit[{keys:inputs}][{keys:guidStr}]`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.saveSepaIpLimit(req.params.inputs, req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
      )));
}

module.exports = addRoutes;